export function handleUnauthorizedError() {
  document.location.href = document.location.origin + '/login';
}
